import createHistory from 'history/createBrowserHistory';
import { BASENAME } from '../utilities/processFunctions';

export const history = createHistory({
  basename: BASENAME
});
